module.exports = __webpack_public_path__ + "static/media/first_pull_request.765770c3.png";